/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import WelcomeBody from './WelcomeBody';
import ActionItem from '../ActionItem';
import getImg from '../../../Utils/getImg.js';
import { InternationalizationContext } from '../../../../src/Utils/Contexts';
import { getLabelTranslation, T, TString } from '../Response/Utils';

const CustomWelcomeBody = styled(WelcomeBody)`
  background: #fff;
  color: #000;
  padding: 0 0 30px 0;
  overflow: auto;
`;

const WelcomeText = styled.div`
  font-size: 16px;
  background-color: ${props => {
    return props.data.primaryColor ? props.data.primaryColor : '#0267f0';
  }};
  color: #fff;
  margin-bottom: 30px;
  padding: 15px 30px 40px 40px;
  border-bottom-left-radius: 80px;
  & div {
    font-size: 28px;
    font-weight: 300;
  }
  min-height: 160px;
`;

const QuickLinksBlock = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding: 20px 40px;
`;

const FlexIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background: #f8f8f8;
  margin-bottom: 10px;
  cursor: pointer;
`;

const CustomQuickLink = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(33.33% - ${80 / 6}px);
  margin-right: ${80 / 6}px;
  margin-bottom: 15px;

  ${FlexIcon}:hover {
    background: #00dc94;

    & svg {
      fill: #fff;
      animation: none;
    }
  }

  & > div:last-child {
    font-size: 12px;
    color: #959191;
    border: 0;
    border-radius: 0;
    background: transparent;
    margin: 0;
    padding: 0;
  }

  & > div:last-child:hover {
    background: transparent;
    color: #959191;
    animation: none;
  }
`;

const Theme2 = props => {
  if (!props.showWelcomeScreen) {
    return null;
  }
  const intlContext = React.useContext(InternationalizationContext);
  const quickLinks = JSON.parse(props.data.quicklinks);
  return (
    <CustomWelcomeBody {...props}>
      <WelcomeText {...props}>
        <T labelName="helloLabel" />
        <br />
        {props.data.welcomeMessage}
      </WelcomeText>
      {props.quickLinks && props.quickLinks.length ? (
        <div style={{ fontSize: '13px', paddingLeft: '40px' }}>
          <T labelName="quickLinksLabel" />
        </div>
      ) : null}
      <QuickLinksBlock>
        {quickLinks.map((e, i) => {
          return (
            <CustomQuickLink key={i}>
              <FlexIcon
                onClick={event => event.currentTarget.nextSibling.click()}
              >
                <img
                  src={getImg(`welcomeScreen/${props.theme}/${i + 1}.svg`)}
                  alt={TString({ labelName: 'welcomeScreenLabel' })}
                />
              </FlexIcon>
              <ActionItem
                actionLabel={getLabelTranslation(
                  e,
                  intlContext.currentLanguage,
                  'linkText'
                )}
                actionValue={getLabelTranslation(
                  e,
                  intlContext.currentLanguage,
                  'linkValue'
                )}
                handleSubmit={props.handleSubmit}
              ></ActionItem>
            </CustomQuickLink>
          );
        })}
      </QuickLinksBlock>
    </CustomWelcomeBody>
  );
};

export default Theme2;
